module.exports = __webpack_public_path__ + "static/p4-97ff3548e235db7ac483bcce7759168b.png";